import React, { useEffect } from 'react';

import { MDText } from 'i18n-react';

import { formatPhoneNumber, isObject } from 'Utilities/helpers';
import { isOfficeHours } from 'Utilities/isOfficeHours/isOfficeHours';

import { Email, Phone } from '../../../../components/misc/ContactButtons/ContactButtons';
import { QuestionBody } from '../QuestionBody/QuestionBody';
import { QuestionBodyAside } from '../QuestionBodyAside/QuestionBodyAside';
import { QuestionHeader } from '../QuestionHeader/QuestionHeader';
import { TOO_MANY_REQUESTS } from '../VehicleProfiling.constants';
import { useGeneralErrorToast } from '../VehicleProfiling.hooks';
import LocalTexts from '../VehicleProfilingTexts.json';

import underConstructionIcon from './under-construction.svg';

import styles from './ErrorPage.module.scss';

const LocalT = new MDText(LocalTexts);
const formattedLandline = formatPhoneNumber();

type ErrorResponse = Record<string, any>;

type ErrorPageProps = {
  error?: ErrorResponse | boolean;
  questionSubtitle?: React.ReactNode;
}

export const ErrorPage = ({ error, questionSubtitle }: ErrorPageProps) => {
  const agentsOnline = isOfficeHours();
  const { showErrorToast } = useGeneralErrorToast();

  useEffect(() => {
    const checkIfObject = (value: any): value is ErrorResponse => isObject(value);

    if (checkIfObject(error) && error?.message === TOO_MANY_REQUESTS) {
      showErrorToast({
        content: LocalT.translate('errorPage.toast.body'),
        heading: LocalT.translate('errorPage.toast.title'),
      });
    }
  }, [error, showErrorToast]);

  return (
    <>
      <QuestionHeader
        subtitle={questionSubtitle || LocalT.translate('errorPage.header.subTitle')}
        title={LocalT.translate('errorPage.header.title')}
      />
      <QuestionBody withoutProgressBar className={styles.body}>
        <div className={styles.messageBox}>
          <p>{LocalT.translate('errorPage.body.problem')}</p>
          {agentsOnline ? (
            <>
              <p>{LocalT.translate('errorPage.body.call')}</p>
              <Phone
                landlineNoSpace={formattedLandline.number}
                landlineWithSpace={formattedLandline.pretty}
              />
              <p>
                <span className={styles.bold}>{LocalT.translate('errorPage.body.boldOpen')}</span>
                {LocalT.translate('errorPage.body.openTime')}
              </p>
            </>
          ) : (
            <>
              <p>{LocalT.translate('errorPage.body.contact')}</p>
              <p>{LocalT.translate('errorPage.body.closed')}</p>
              <div className={styles.contact}>
                <Email email={LocalT.translate('email') as string} />
              </div>
            </>
          )}
        </div>
        <QuestionBodyAside withoutProgressBar>
          <img
            className={styles.diversion}
            height="282"
            src={underConstructionIcon}
            width="424"
          />
        </QuestionBodyAside>
      </QuestionBody>
    </>
  );
};
